module.exports = __webpack_public_path__ + "img/职工疗养.ccc1f99b.png";